// Title-case a string, accent-aware (unlike PHP ucwords(strtolower()) which
// leaves multibyte letters like Á untouched, producing "TomÁs").
export function titleCase(str) {
    return (str ?? '')
        .toLocaleLowerCase()
        .replace(/(^|[\s\-'])(\p{L})/gu, (m, sep, ch) => sep + ch.toLocaleUpperCase());
}
